import {createStyles} from '@mantine/core';

import {getExtensionIcon} from 'dev-platform/extensionIconMapper';
import {ExtensionType} from 'graphql-client/__generated/graphqlGlobalTypes';

const ICON_SIZE = 24;

const useStyles = createStyles((theme) => ({
  // getExtensionIcon puts this class on its root element, which is either the <img> itself or a
  // <span> wrapping a BenchlingIcon glyph. These rules size and center both cases within a square box.
  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.xs,
    border: `1px solid ${theme.colors.gray[3]}`,
    overflow: 'hidden',
    objectFit: 'contain',
  },
}));

/**
 * Square icon for an AI Connector row. Prefers the connector's own `iconUrl`, then a curated static
 * image mapped by extension id, then a default MCP glyph — matching the icon logic used elsewhere for
 * MCP extensions.
 */
export default function ConnectorIcon({
  extensionDefinitionId,
  iconUrl,
}: {
  extensionDefinitionId: string | null;
  iconUrl: string | null;
}): JSX.Element {
  const {classes} = useStyles();
  return getExtensionIcon(extensionDefinitionId ?? '', {
    iconUrl,
    extensionType: ExtensionType.MCP_SERVER,
    className: classes.icon,
  });
}
